module.exports = __webpack_public_path__ + "static/NunitoSans-Regular-9c6a1ff29aaba0c21496eac04be062df.woff2";